import { Component, OnChanges, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';


import { UtesService } from './utes.service';
import { DialogUtes } from '../dialog/utes/dialog.component.utes';

import { MatDialog } from '@angular/material/dialog'

import { ListUtesService } from './list.service';
import { saveAs } from 'file-saver';

import { IFRUtes } from './utes.interfaces';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface PeriodicElement {
   id: string,
   codi: string,
   nom: string,
   nif: string,
   compte: string,
   codi1: string,
   gerent: string,
   gestiona: string,
   alta: Date,
   inoperativa: Date,
   baixa: Date,
   caducitat_digital: Date,
   capital_social: string,
   percent_propi: string
}

const ELEMENT_DATA: PeriodicElement[] = [
  {id: 'NEW', codi: null, nom: null, nif: null, compte: null, codi1: null, gerent: null, gestiona: null,
   alta: null, inoperativa: null, baixa: null, caducitat_digital: null, capital_social: null, percent_propi: null},
];

@Component({
  selector: 'mcrit-gestio-utes',
  templateUrl: 'utes.component.html',
  styleUrls: ['utes.component.scss']
})
export class UtesComponent implements OnInit, OnDestroy {
   @Input('elementList') elementList: any;
   @Output('requestRows') requestRows = new EventEmitter();

   private routeParamsSubs: any;
   private unsubscriber : Subject<void> = new Subject<void>();

   public showAsyncProgress: boolean = false;
   public utesData: Array<IFRUtes> = [];

   private activeFilters: any = {};
   private currentOrdering: any = {};
   private orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

   public firstRegisterShown: number = 0;
   public lastRegisterShown: number;
   public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
   public data: Array<number> = [];

   public showFilters: boolean = true;
   public orderingParameters: any;
   public export: boolean = false;
   public showDialog: boolean = false;
   public editUtesData: IFRUtes;

   private UtesModel: IFRUtes = {
      'id': 'NEW',
      'codi': null,
      'nom': null,
      'nif': null,
      'compte': null,
      'codi1': null,
      'gerent': null,
      'gestiona': null,
      'alta': null,
      'inoperativa': null,
      'baixa': null,
      'caducitat_digital': null,
      'capital_social': null,
      'percent_propi': null
   };
  
  public displayedColumns: string[] = ['codi', 'nom', 'nif', 'codi1', 'gerent', 'gestiona', 'alta',
     'inoperativa', 'baixa', 'caducitat_digital', 'percent_propi'];
  public dataSource = ELEMENT_DATA;

   public toggleFiltersVisibility() {
     this.showFilters = !this.showFilters;
   }

  public computeActiveFilters($event){
     this.activeFilters = $event;

     this.firstRegisterShown = 1 + this.listUtesService.currentPage * this.listUtesService.rowsPerPage;
     this.requestRowsToParent();
   }

   private computeDisplayedRows(): void {
     this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listUtesService.rowsPerPage - 1, this.utesData.length);
   }

   public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

  private requestRowsToParent(): void {
      this.utesService.get(
        this.listUtesService.rowsPerPage, //Limit
        (this.firstRegisterShown?this.firstRegisterShown:1) - 1, //Skip
        this.activeFilters //FILTRE DELS REGISTRES QUE ES MOSTREN A INICI
        ,{}//Conds a aplicar. Per defecte LIKE %%
        ,this.currentOrdering //ORDRE DELS TREBALLS QUE ES MOSTREN A INICI (tematica3, data_aprovacio)
      ).subscribe(
        data => {
          if(!this.export){this.utesData = data["rows"];this.computeDisplayedRows();}
          else{this.export = false;
            var csvData = this.convertToCSV(data);
            var file = new Blob(["\ufeff",csvData], { type: 'text/csv;charset=utf-8' });
            saveAs(file, "export.csv");
          }
        },
        error => console.log(error)
      );
  }

  public addUtes(): void {
    this.editUtesData = Object.assign(this.UtesModel);
    
    let dialogFactRef=this.dialog.open(DialogUtes, {disableClose: true, height: '450px', width: '1000px', data: this.editUtesData })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editUtesData = results;
      this.addOrUpdate();
    });
  }

  public editUtes(oportunitat: IFRUtes): void {
    this.editUtesData = Object.assign(oportunitat);
    let dialogFactRef=this.dialog.open(DialogUtes, {disableClose: true, height: '450px', width: '1000px', data: this.editUtesData })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editUtesData = results;
      this.addOrUpdate();
    });
  }

  public addOrUpdate(): void {
    this.showAsyncProgress = true;

    if (this.editUtesData.id === 'NEW') {//crear UTE
      this.utesService.createUtes(this.editUtesData)
        .subscribe(newClientSoci => {
            console.log("S'ha creat l'element");window.location.reload();});
    } else {//actualitzar  UTE
      this.utesService.updateUtes(<number> this.editUtesData.id, this.editUtesData)
        .subscribe(updatedClientSoci => {console.log("S'han desat les dades");this.showAsyncProgress = false;
        });
    };
  }

  public exportar(){this.export=true;this.requestRowsToParent();};

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  public requestPrevious(): void {
     this.listUtesService.currentPage = Math.max(0, this.listUtesService.currentPage - 1);
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public requestNext(): void {
     this.listUtesService.currentPage = this.listUtesService.currentPage + 1;
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public setRowPerPage(rowsPerPage: number) {
    this.listUtesService.rowsPerPage = rowsPerPage;
    this.requestRowsToParent();
  }

  public utesFilters: Array<any>
  public ordreCamps: Array<any>

  constructor(public translate: TranslateService, public languageService: LanguageService, private utesService: UtesService, public dialog:MatDialog, public listUtesService: ListUtesService, private route: ActivatedRoute) { }

  private buildStaticData(): void {
    this.utesFilters = [
      {
        inputs: [
          {
            name: 'estat',
            type: 'checkbox',
            values: [
              {
                text: this.translate.instant('utes.estats.stateOperativa'),
                name: 'stateOperativa',
                value: true
              }
            ]
          }
        ]
      },
      {
        inputs: [
          {
            name: 'text',
            type: 'text',
            values: [
              {
                text: this.translate.instant('propostaMi.camps.codi'),
                name: 'codi',
                value: this.listUtesService.getSearchValues('codi') //valor a mostrar
              },
              {
                text: this.translate.instant('usuaris.colNom'),
                name: 'nom',
                value: this.listUtesService.getSearchValues('nom') //valor a mostrar
              },
              {
                text: this.translate.instant('utes.colNIF'),
                name: 'nif',
                //autocomplete: 'nif',
                value: this.listUtesService.getSearchValues('nif')
              }
            ]
          }
        ]
      }
    ];

    // NOTA: abans es reduïa sobre 'utesFilters' (grups de filtres), cosa que no té sentit
    // perquè 'curr[0]' d'un objecte {inputs:[...]} és undefined. S'ha de reduir sobre les
    // columnes reals de la taula, que és el que 'displayedColumns' ja conté.
    this.orderingParameters = this.displayedColumns.reduce((acum, curr) => {
      acum[curr] = 0;
      return acum;
    }, {});
  }

  ngOnInit() {
    this.ordreCamps = [];

    this.buildStaticData();

    // Si l'usuari canvia d'idioma en calent, reconstruïm els filtres
    this.translate.onLangChange
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(() => this.buildStaticData());

    ['alta'].map(item => this.currentOrdering[item] = this.orderingCycle[2]);
    this.computeActiveFilters({});

  history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

}
